// extracted by mini-css-extract-plugin
module.exports = {"left":"styles_left__3vnKz","right":"styles_right__2b2UH","checkbox":"styles_checkbox__28EZ7"};